import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    gridList: {
      width: '100%',
    },

    imagesEvent: {
      '& .MuiIconButton-root': {
        display: 'none',
      },
      '& .Mui-checked': {
        display: 'inline-flex',
      },
      '&:hover': {
        '& .MuiIconButton-root': {
          display: 'inline-flex',
        },
      },

      '& img': {
        border: '1px solid #EEEEEE',
        top: 0,
        maxHeight: '100%',
        transform: 'none',
        maxWidth: '100%',
        height: '100%',
        width: '100%',
        left: 0,
        objectFit: 'contain',
      },
    },

    value: {
      fontSize: theme.typography.pxToRem(13),
    },
    label: {
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(13),
    },
    comments: {
      margin: '15px 0',
      fontSize: theme.typography.pxToRem(13),
      '& label': {
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(13),
      },
    },
    divider: {
      borderTop: '1px solid lightgray',
      margin: '10px 0',
    },
  };
});

export { useStyles };
